<mat-card class="postgenie-card">
  <mat-card-content class="h-100 content-container">
    <!-- Fieldset to disable/blur the content based on the disablePage condition -->
    <fieldset
      [disabled]="disablePage$"
      [ngClass]="{ blur: disablePage$, 'no-blur': !disablePage$ }"
      class="h-100"
    >
      <div class="row h-100">
        <div class="header-wrapper">
          <div class="headline">
            <h3>Generate new post</h3>
          </div>
          <div class="header-icon">
            <mat-icon (click)="closeDialog('')">close</mat-icon>
          </div>
        </div>
        <div class="stepper">
          <mat-tab-group
            class="h-100"
            animationDuration="{{ animationTime }}"
            [(selectedIndex)]="this.step"
            (selectedIndexChange)="onTabChanged($event)"
          >
            <mat-tab class="h-100">
              <ng-template mat-tab-label>
                <div class="stepper-header">
                  <div
                    *ngIf="stateSignal$().workflow.workflow.activeStep == 1"
                    class="circle"
                  >
                    1
                  </div>
                  <div
                    *ngIf="stateSignal$().workflow.workflow.activeStep > 1"
                    class="circle"
                  >
                  <mat-icon>check</mat-icon>
                  </div>
                  <div>Post description</div>
                </div>
              </ng-template>
              <ng-template matTabContent>
                <div class="stepper-content">
                  <post-description
                    (disablePageEvent)="this.setDisablePageStatus($event)"
                  ></post-description>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab
              class="h-100"
              [disabled]="stateSignal$().workflow.workflow.activeStep < 2"
            >
              <ng-template mat-tab-label>
                <div class="stepper-header">
                  <div
                    *ngIf="stateSignal$().workflow.workflow.activeStep < 3"
                    class="circle"
                  >
                    2
                  </div>
                  <div
                    *ngIf="stateSignal$().workflow.workflow.activeStep >= 3"
                    class="circle"
                  >
                  <mat-icon>check</mat-icon>
                  </div>
                  <div>Goal/Objective</div>
                </div>
              </ng-template>
              <ng-template matTabContent>
                <div class="stepper-content">
                  <post-goal
                    (disablePageEvent)="this.setDisablePageStatus($event)"
                  ></post-goal>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab
              class="h-100"
              [disabled]="stateSignal$().workflow.workflow.activeStep < 3"
            >
              <ng-template mat-tab-label>
                <div class="stepper-header">
                  <div
                    *ngIf="stateSignal$().workflow.workflow.status != 'review'"
                    class="circle"
                  >
                    3
                  </div>
                  <div
                    *ngIf="stateSignal$().workflow.workflow.status == 'review'"
                    class="circle"
                  >
                  <mat-icon>check</mat-icon>
                  </div>
                  <div>Tone of post</div>
                </div>
              </ng-template>
              <div>
                <ng-template matTabContent>
                  <div class="stepper-content">
                    <post-tone
                      (disablePageEvent)="this.setDisablePageStatus($event)"
                      (closeDialog)="this.closeDialog('final post')"
                    ></post-tone>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </fieldset>
    <div *ngIf="disablePage$" class="overlay-message">
      <div class="justify-spinner">
        <mat-spinner></mat-spinner>
      </div>
      {{ blurmessage[expectedResult] }}
    </div>
  </mat-card-content>
</mat-card>
